const meta = {
  slack: 'Slack graph unfurling',
};

export default meta;
